import { noop } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { appActions } from 'redux/ducks/app';
import { courseActions } from 'reports/cw/redux/ducks/courses';
import { querySelectorWrapper } from 'services/method-wrapper.service';
import { selectedRadioClassName } from './CourseSelectionModalHelpers';
var getModalTitle = function (isStudentDetail, studentName) {
    if (isStudentDetail) {
        return "".concat(studentName, " was found in multiple courses you have access to.");
    }
    return 'Your account is associated with multiple courses.';
};
var getButtonDescription = function (submitButtonTitle, isStudentDetail) {
    if (submitButtonTitle) {
        return submitButtonTitle;
    }
    return isStudentDetail ? 'View Sherpath Performance & Engagement' : 'Review Mastery in HESI Focus Chapters';
};
var useCourseSelectionModalHook = function (_a) {
    var onCloseModal = _a.onCloseModal, initialCourseId = _a.initialCourseId, isStudentDetail = _a.isStudentDetail, studentName = _a.studentName, submitButtonTitle = _a.submitButtonTitle, _b = _a.isSwitchCourse, isSwitchCourse = _b === void 0 ? true : _b, _c = _a.courseOptions, courseOptions = _c === void 0 ? [] : _c, _d = _a.courseSections, courseSections = _d === void 0 ? [] : _d, _e = _a.onSubmitSelectedCourse, onSubmitSelectedCourse = _e === void 0 ? noop : _e, _f = _a.handleRedirectPage, handleRedirectPage = _f === void 0 ? noop : _f;
    var dispatch = useDispatch();
    var _g = useState(initialCourseId), tempCourseId = _g[0], setTempCourseId = _g[1];
    var title = getModalTitle(isStudentDetail, studentName);
    var goButtonDescription = useMemo(function () { return getButtonDescription(submitButtonTitle, isStudentDetail); }, [submitButtonTitle, isStudentDetail]);
    var selectOptions = useMemo(function () {
        if (!(courseSections === null || courseSections === void 0 ? void 0 : courseSections.length)) {
            return courseOptions;
        }
        // Remove duplicate objects by id
        var allCourseSectionIds = courseSections.map(function (course) { return course.id; });
        // "index + 1" is the fromIndex parameter. This checks for duplicate ids from index + 1 to the end of the array
        var allUniqueCourseSections = courseSections.filter(function (_a, index) {
            var id = _a.id;
            return !allCourseSectionIds.includes(id, index + 1);
        });
        return allUniqueCourseSections.map(function (_a) {
            var id = _a.id, courseName = _a.courseName;
            return ({
                courseId: id,
                courseName: courseName
            });
        });
    }, [courseSections, courseOptions]);
    useEffect(function () {
        var selectedRadioSelector = ".".concat(selectedRadioClassName);
        var selectedRadio = querySelectorWrapper(selectedRadioSelector);
        if (selectedRadio) {
            selectedRadio.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
    }, []);
    var radioChangeHandler = function (value) {
        setTempCourseId(value);
    };
    var goButtonHandler = function () {
        if (tempCourseId) {
            onSubmitSelectedCourse(tempCourseId);
            if (isSwitchCourse) {
                var changeCourse = courseSections.find(function (_a) {
                    var id = _a.id;
                    return Number(id) === Number(tempCourseId);
                });
                if (changeCourse) {
                    dispatch(appActions.setSelectedCourse(changeCourse.id));
                    dispatch(courseActions.setCourseSectionInfo(changeCourse));
                }
                handleRedirectPage();
            }
            onCloseModal();
        }
    };
    return { tempCourseId: tempCourseId, radioChangeHandler: radioChangeHandler, goButtonHandler: goButtonHandler, selectOptions: selectOptions, title: title, goButtonDescription: goButtonDescription };
};
export default useCourseSelectionModalHook;
